// extracted by mini-css-extract-plugin
export var csatScore = "_nh-5";
export var header = "_nh-1";
export var panelWrapper = "_nh-2";
export var postPreview = "_nh-3";
export var rightContent = "_nh-0";
export var wrappingText = "_nh-4";